module.exports = __webpack_public_path__ + "media/images/org-gender-icon-5b4aab61.svg";